export default __webpack_public_path__ + "static/media/1614.10ceb454.png";